<template>
	<div class="server_list">
		<Content :style="{margin: '0 0 0 10px', padding: '14px', minHeight: layout.minHeight, background: '#eee'}">
			<div class="tools">
				<Row>
					<Col span="4">
						<Button type="success" @click="addHost()">添加主机</Button>
						<Button type="error" @click="addHost()">删除主机</Button>
					</Col>
				</Row>
			</div>
			<div class="table">
				<Table border ref="selection" :columns="tableData.columns.host" :data="tableData.data.host.data"></Table>
			</div>
			<div class="foot"></div>
		</Content>
	</div>
</template>

<script>
	export default {
		name: "server_list",
		data(){
			return {
				layout: {
					minHeight: '700px',
				},
				tableData: {
					columns: {
						host: [
							{
								type: 'selection',
								width: 60,
								align: 'center',
							},
							{
								title: '主机名',
								key: 'hostname'
							},
							{
								title: 'IP/域名',
								key: 'domain'
							},
							{
								title: '鉴权类型',
								key: 'permission_type'
							},
							{
								title: '创建时间',
								key: 'created_at'
							},
							{
								title: '更新时间',
								key: 'updated_at'
							},
							{
								title: '操作',
								key: 'action',
								width: 250,
								align: 'center',
								render: (h, params)=>{
									return h('div', [
										h('Button', {
											props: {
												type: 'primary',
												size: 'small'
											},
											style: {
												marginRight: '5px'
											},
											on: {
												click: ()=>{
													this.editHost(params)
												}
											}
										}, '编辑'),
										h('Button', {
											props: {
												type: 'success',
												size: 'small'
											},
											style: {
												marginRight: '5px'
											},
											on: {
												click: ()=>{
												}
											}
										}, 'SSH'),
										h('Button', {
											props: {
												type: 'error',
												size: 'small'
											},
											style: {
												marginRight: '5px'
											},
											on: {
												click: ()=>{
													this.deleteHost(params.host_id)
												}
											}
										}, '删除'),
									])
								}
							}
						]
					},
					data: {
						host: [],
					}
				}
			}
		},
		methods: {
			resizeHeight(){
				let main_content_height = window.innerHeight;
				this.layout.minHeight = (main_content_height - 35 - 120) + 'px';
			},
			deleteSelectedHost(){
				let selected_cols_arr = this.$refs.selection.data;
				let selected_id_arr = [];
				_.each(selected_cols_arr, function(item){
					selected_id_arr.push(item.host_id);
				})
			},
			addHost(){
				this.$router.push('/dashboard/server/add');
			},
			editHost(column){
				let id = column.row.server_id;
				this.$router.push({
					name: 'DashboardServerEdit',
					params: {
						id,
					}
				})
			},
			get_list(){
				this.$fetch.user.get_user_server_list().then(data=>{
					this.tableData.data.host = data;
				});
			}
		},
		mounted(){
			let that = this;
			this.resizeHeight();
			$(window).resize(function(){
				that.resizeHeight();
			});
		},
		created(){
			this.get_list();
		}
	}
</script>

<style scoped lang="less">
	.server_list {
		.table {
			margin-top: 10px;
		}
		
		.foot {
			margin-top: 5px;
		}
	}

</style>
